import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Borang Peperiksaan", -1)
const _hoisted_2 = { class: "row g-5 g-xl-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Borang Perkhidmatan", -1)
const _hoisted_4 = { class: "row g-5 g-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCardWidget1 = _resolveComponent("CustomCardWidget1")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examinations, (examination, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-6",
          key: index
        }, [
          _createVNode(_component_CustomCardWidget1, {
            "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
            background: `abstract-${Math.ceil(Math.random() * (4 - 1) + 1)}.svg`,
            title: examination.nama_borang,
            description: 
          _ctx.buildDescription(examination.perakuan, examination.medan_tambahan)
        ,
            path: 
          '/pentadbiran/tetapan-borang/' + examination.id + '/kemaskini'
        
          }, null, 8, ["background", "title", "description", "path"])
        ]))
      }), 128))
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-6",
          key: index
        }, [
          _createVNode(_component_CustomCardWidget1, {
            "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
            background: `abstract-${Math.ceil(Math.random() * (4 - 1) + 1)}.svg`,
            title: service.nama_borang,
            description: 
          _ctx.buildDescription(service.perakuan, service.medan_tambahan)
        ,
            path: 
          '/pentadbiran/tetapan-borang/' + service.id + '/kemaskini'
        
          }, null, 8, ["background", "title", "description", "path"])
        ]))
      }), 128))
    ])
  ], 64))
}